import { render, staticRenderFns } from "./ClickAndBuyMediaForm.vue?vue&type=template&id=6fc3427e&scoped=true"
import script from "./ClickAndBuyMediaForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyMediaForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyMediaForm.vue?vue&type=style&index=0&id=6fc3427e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3427e",
  null
  
)

export default component.exports